import { Injectable } from '@angular/core';
import { QuestionStructureOptions } from '../models/question/question-options.model';
import { QuestionStructureRepeater } from '../models/question/question-repeater.model';
import { QuestionStructure } from '../models/question/question-structure.model';
import { Question } from '../models/question/question.model';
import { RendererQuestionsRepository } from '../repositories/renderer-questions.repository';

@Injectable({ providedIn: 'root' })
export class RendererQuestionsQuery {
  constructor(
    protected rendererQuestionsRepository: RendererQuestionsRepository,
  ) {}

  getQuestions(questionIds: string[]): Question[] {
    const questions = [];
    for (const questionId of questionIds) {
      questions.push(this.rendererQuestionsRepository.get(questionId));
    }
    return questions.filter(Boolean);
  }

  getQuestionsFromOrder(order: string[][]): Question[] {
    const questions = [];
    for (const orderRow of order) {
      for (const questionId of orderRow) {
        questions.push(this.rendererQuestionsRepository.get(questionId));
      }
    }
    return questions.filter(Boolean);
  }

  getChildQuestionOrder(structure: QuestionStructure): string[][] {
    let order;
    if (this.isOptionQuestion(structure)) {
      order = structure.followUpQuestionsOrder;
    } else if (this.isRepeaterQuestion(structure)) {
      order = structure.repeaterQuestionsOrder;
    }
    return order;
  }

  isOptionQuestion(
    structure: QuestionStructure,
  ): structure is QuestionStructureOptions {
    return (
      (structure as QuestionStructureOptions).followUpQuestionsOrder !==
      undefined
    );
  }

  isRepeaterQuestion(
    structure: QuestionStructure,
  ): structure is QuestionStructureRepeater {
    return (
      (structure as QuestionStructureRepeater).repeaterQuestionsOrder !==
      undefined
    );
  }
}
